import React from "react";
import { ShieldCheck, RotateCcw, Headphones } from "lucide-react";
import { couriers } from "../mock";

const Shipping = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-[#0f2846] text-3xl md:text-4xl font-bold">Spedizione gratuita in tutta Italia</h2>
          <div className="w-24 h-1 bg-[#e8464a] mx-auto mt-4 rounded-full" />
          <p className="text-slate-500 mt-5">Lavoriamo con i principali corrieri espresso italiani. Imballaggio rinforzato, tracking incluso, niente costi extra.</p>
        </div>
        <div className="grid sm:grid-cols-3 gap-6 mt-12">
          {couriers.map((c, i) => (
            <div key={i} className="bg-[#f4f6f9] rounded-2xl border border-slate-100 p-8 text-center hover:shadow-md transition-all">
              <div className="font-display font-bold text-[#0f2846] text-2xl tracking-wide">{c.code}</div>
              <div className="text-slate-500 text-sm mt-1">{c.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          <div className="bg-[#0f2846] rounded-2xl p-7 text-white">
            <ShieldCheck size={30} className="text-[#22c35e]" />
            <div className="mt-4 text-xs uppercase tracking-widest text-white/50 font-semibold">Garanzia</div>
            <p className="mt-1 font-semibold"><b>Garanzia ufficiale 12-24 mesi</b><br /><span className="font-normal text-white/70 text-sm">Polizza assicurativa primaria su tutti i motori rettificati</span></p>
          </div>
          <div className="bg-[#f4f6f9] rounded-2xl p-7 border border-slate-100">
            <RotateCcw size={30} className="text-[#e8464a]" />
            <h3 className="font-display font-bold text-[#0f2846] text-lg mt-4">Soddisfatti o rimborsati - Reso entro 14 giorni</h3>
            <p className="text-slate-500 text-sm mt-2 leading-relaxed">Se il motore non corrisponde a quanto descritto, hai 14 giorni per il reso. Ti rimborsiamo l'intero importo o sostituiamo il motore.</p>
          </div>
          <div className="bg-[#f4f6f9] rounded-2xl p-7 border border-slate-100">
            <Headphones size={30} className="text-[#0f2846]" />
            <h3 className="font-display font-bold text-[#0f2846] text-lg mt-4">Consulenza tecnica gratuita prima dell'acquisto</h3>
            <p className="text-slate-500 text-sm mt-2 leading-relaxed">Hai dubbi su quale motore scegliere? I nostri tecnici ti aiutano gratuitamente a identificare il pezzo giusto per il tuo veicolo.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shipping;
